import React from 'react';
import { Button } from 'shadcn-ui';
import { FormButtonLayoutProps } from 'ui-builder';

function ShadcnCancelButtonLayout(props: FormButtonLayoutProps) {
  return (
    <Button
      type="button"
      variant="outline"
      size="default"
      onClick={(e) => {
        e.preventDefault();
        props.onClick();
      }}
      data-testid={props.testId}
    >
      {props.text}
    </Button>
  );
}

export default ShadcnCancelButtonLayout;
